import {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {getPlantStrain, updateStrainName, updateStrainDescription} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";
import {Card, Row} from 'antd';
import {TextChangeWidget} from "../widget/TextChangeWidget";
import {WholesaleProductsCard} from "./WholesaleProductsCard";

export const PlantStrainView = ({io}) => {
    const [strain, setStrain] = useState(undefined);

    const params = useParams();
    const {strainId} = params;
    const {onApiFail, refresh, onRefresh} = io;

    useEffect(()=> {
        getPlantStrain(strainId).then(r => {
            setStrain(r);
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }, [strainId, refresh, onApiFail]);

    const onNameChange = (val) => {
        updateStrainName(strain.id, val).then(r => {
            if (onRefresh) { onRefresh() }
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
    }

    const onDescriptionChange = (val) => {
        updateStrainDescription(strain.id, val).then(r => {
            if (onRefresh) { onRefresh() }
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
    }

    const rowStyle={
        marginTop: '5px', marginBottom: '5px',
    }

    const divStyle = {
        textAlign: 'left'
    }

    if (strain === undefined) {
        return <div />
    }

    return <div style={divStyle}>
        <Card title={<b>{`Strain ${strain.name}`}</b>}>
            <Row style={rowStyle}>
                <TextChangeWidget onTextSave={onNameChange} text={strain.name} maxLength={512} rows={1} />
            </Row>
            <Row style={rowStyle}>
                <TextChangeWidget onTextSave={onDescriptionChange} text={strain.description} maxLength={2048} rows={1} />
            </Row>
        </Card>
        <WholesaleProductsCard strainId={strainId} onApiFail={onApiFail} onRefresh={onRefresh} refresh={refresh} />
    </div>
}